import React from 'react'
import Header from '../Components/Header'
import Footer from '../Components/Footer'
import Security from '../Pages/Security'

function SecurityLayout() {
  return (
    <>
    <Header />
    <Security />
    <Footer />
    </>
  )
}

export default SecurityLayout